import gmx_zMixins         from '../../../../includes/Jmixins/zMixins.js'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues.js'
import lmx_localData            from '../primitives/localData.js'
import lmx_watching             from './Watching.js'
import lmx_Events               from './Events.js'

import draw_Forms               from './draw_Forms.js'
import draw_Radial              from './draw_Radial.js'

import gantt_Header             from './gantt_Header.js'
import gantt_Chart              from './gantt_Chart.js'

import draw_Table               from './draw_Table.js'


export default {

  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_localData,
    lmx_watching,
    lmx_Events,

    draw_Forms,
    draw_Radial,

    gantt_Header,
    gantt_Chart,

    draw_Table,

  ],
  
}
